/* Click-to-load video facade for the Ambassador Video section.
   Scoped as a custom element so multiple instances never collide. */
if (!customElements.get('ambassador-video')) {
  customElements.define(
    'ambassador-video',
    class AmbassadorVideo extends HTMLElement {
      connectedCallback() {
        const trigger = this.querySelector('.ambassador-video__poster');
        if (!trigger) return;
        trigger.addEventListener('click', () => this.load(), { once: true });

        // YouTube only generates maxresdefault.jpg for some uploads. A missing
        // one is NOT an image error: YouTube answers 404 with a real 120x90
        // grey placeholder JPEG, which decodes fine and never fires 'error'.
        // Detect it by size and swap in hqdefault (always present; its 4:3
        // letterbox bars are cropped away by object-fit: cover).
        const poster = trigger.querySelector('img[data-fallback]');
        if (poster) {
          const check = () => {
            if (poster.naturalWidth && poster.naturalWidth < 480) {
              poster.src = poster.dataset.fallback;
            }
          };
          if (poster.complete) {
            check();
          } else {
            poster.addEventListener('load', check, { once: true });
            poster.addEventListener('error', () => {
              poster.src = poster.dataset.fallback;
            }, { once: true });
          }
        }
      }

      load() {
        const template = this.querySelector('template');
        const frame = this.querySelector('.ambassador-video__frame');
        if (!template || !frame) return;
        frame.appendChild(template.content.firstElementChild.cloneNode(true));
        const poster = this.querySelector('.ambassador-video__poster');
        if (poster) poster.remove();
        const iframe = frame.querySelector('iframe');
        if (iframe) iframe.focus();
      }
    }
  );
}
